<template>
  <div>
    <div class="card-container memberDetails">
      <a-form ref="detailForm" class="detail-form">
        <div class="card-title">
          设备基本信息
        </div>
        <div class="card-content">
          <a-row>
            <a-col :span="6">
              <a-form-item
                label="设备名称"
                v-bind="formItemLayout"
              >
                {{ detail.name }}
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item
                label="设备类型"
                v-bind="formItemLayout"
              >
                <span v-if="detail.scenario === '1'">
                  智能分类站
                </span>
                <span v-if="detail.scenario === '2'">
                  智能回收站
                </span>
                <span v-if="detail.scenario === '4'">
                  智能垃圾房
                </span>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item
                label="设备编号"
                v-bind="formItemLayout"
              >
                {{ detail.productId }}
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item
                label="所在区域"
                v-bind="formItemLayout"
              >
                {{ detail.areaName }}
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6">
              <a-form-item
                label="所在街道"
                v-bind="formItemLayout"
              >
                {{ detail.street }}
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item
                label="所在小区"
                v-bind="formItemLayout"
              >
                {{ detail.estateName }}
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item
                label="设备安装时间"
                v-bind="formItemLayout"
              >
                {{ detail.createTime }}
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </a-form>
    </div>

    <div class="card-container">
      <div class="title card-title">
        运营数据分析
        <div class="right">
          <a-radio-group
            v-model="type"
            class="group-radio"
            @change="changeType"
          >
            <a-radio-button value="0">
              总计
            </a-radio-button>
            <a-radio-button value="1">
              最近3天
            </a-radio-button>
            <a-radio-button value="2">
              最近7天
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div class="card-content" style="height:30px">
        <div id="line_container" class="g2-container">
          <div v-if="!holdTrend.length" class="no-data">
            <a-icon type="frown" style="font-size: 18px" />
            <span>暂无数据～</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="card-content mb40 mt40">
      <a-row>
        <a-col
          :span="24" type="flex" align="middle"
          style="text-align:center;"
        >
          <a-button class="mr8" @click="back">
            返回
          </a-button>
        </a-col>
      </a-row>
    </div> -->
  </div>
</template>

<script>
import { getScoreDetail } from '@/api/statistics'
import G2 from '@antv/g2'
export default {
  data () {
    return {
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      detail: {},
      type: '0',
      linechart: null,
      holdTrend: []
    }
  },
  mounted () {
    this.getDetail()
    this.getLineData()
  },
  methods: {
    getDetail () {
      const detail = JSON.parse(this.$route.query.info)
      this.detail = detail
    },
    getLineData () {
      const params = {
        id: JSON.parse(this.$route.query.info).id,
        type: this.type
      }
      getScoreDetail(params).then(res => {
        const result = res.result
        this.holdTrend = result
        this.initLine(result)
      })
    },
    initLine (result) {
      if (this.linechart !== null) this.linechart.destroy()
      var data = []
      result.forEach(item => {
        var tmpObj1 = {} // 异味分析
        var tmpObj2 = {} // 设备健康
        var tmpObj3 = {} // 设备外环境
        var tmpObj4 = {} // 设备内环境
        var tmpObj5 = {} // 运营评分
        tmpObj1.type = '异味分析'
        tmpObj1.date = item.day
        tmpObj1.num = item.smell
        data.unshift(tmpObj1)

        tmpObj2.type = '设备健康'
        tmpObj2.date = item.day
        tmpObj2.num = item.health
        data.unshift(tmpObj2)

        tmpObj3.type = '设备外环境'
        tmpObj3.date = item.day
        tmpObj3.num = item.outerScore
        data.unshift(tmpObj3)

        tmpObj4.type = '设备内环境'
        tmpObj4.date = item.day
        tmpObj4.num = item.innerScore
        data.unshift(tmpObj4)

        tmpObj5.type = '运营评分'
        tmpObj5.date = item.day
        tmpObj5.num = item.device
        data.unshift(tmpObj5)
      })
      this.linechart = new G2.Chart({
        container: 'line_container',
        forceFit: true,
        height: 380,
        padding: [50, 60]
      })
      this.linechart.source(data)
      this.linechart
        .line()
        .position('date*num')
        .color('type', ['#3C85FD', '#52c41a', '#00ffff', '#faad14', '#a900ff'])
        .size('type', [2, 2, 2, 2, 2])
      this.linechart
        .point()
        .position('date*num')
        .color('type')
        .size(3)
        .shape('circle')
      this.linechart.legend({
        position: 'top-right',
        marker: 'circle'
      })
      this.linechart.guide().text({// 起始位置（左上角）
        top: true, // 指定 giude 是否绘制在 canvas 最上层，默认为 false, 即绘制在最下层
        position: ['start', 'end'], // 文本的起始位置，值为原始数据值，支持 callback
        content: '分数', // 显示的文本内容
        style: { // 文本的图形样式属性
          fill: '#000000', // 文本颜色
          fontSize: '13' // 文本大小
        }, // 文本的图形样式属性
        offsetX: -25, // x 方向的偏移量
        offsetY: -30 // y 方向偏移量
      })
      this.linechart.guide().text({
        top: true,
        position: ['end', 'start'],
        content: '天',
        style: {
          fill: '#000000',
          fontSize: '13'
        },
        offsetX: 20,
        offsetY: 0
      })
      this.linechart.render()
    },
    back () {
      this.$router.push({
        path: '/finance/FinancialData/plotDevice'
      })
    },
    changeType (val) {
      this.getLineData()
    }
  }
}
</script>

<style lang="stylus" scoped>
.memberDetails
  background-color #fff
  padding 16px 20px
  margin-bottom 20px
  font-size 12px
  color #000
.card-container
  .title
    display flex
    align-items center
    .right
      margin-left auto
  .g2-container
    position relative
    .no-data
      position absolute
      left 50%
      top 50%
      transform translateX(-50%)
      transform translateY(-50%)
</style>
